import { render, staticRenderFns } from "./ContactModuleCountTable.vue?vue&type=template&id=4b995e0c&scoped=true&"
import script from "./ContactModuleCountTable.vue?vue&type=script&lang=js&"
export * from "./ContactModuleCountTable.vue?vue&type=script&lang=js&"
import style0 from "./ContactModuleCountTable.vue?vue&type=style&index=0&id=4b995e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b995e0c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
